module.exports = __webpack_public_path__ + "img/main-doctor.7806ef24.png";